<style lang="scss">
.clsnotification {
  display: flex;
  justify-content: flex-start;
}

.mail-btn {
  float: right;
  background: #869fb7;
  background-image: inherit !important;
}
.holamundo.customnewpopup .vs-popup {
  width: auto !important;
}
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}
.option-inner-wrap {
  margin: 0;
  padding: 0;
}
.option-inner-wrap li {
  list-style: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}
.header-custome span {
  font-size: 15px;
}
.mobile-img {
  height: 600px;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.mobile-img img {
  width: 100%;
  object-fit: contain;
  height: 100%;
}
.push-section {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.push-msg-display-area {
  padding: 15px;
  position: absolute;
  width: 245px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
.push-msg-display-area h3 {
  font-size: 18px;
  word-break: break-all;
}
.push-msg-display-area h4 {
  font-size: 16px;
  word-break: break-all;
}
.push-msg-display-area p {
  word-break: break-all;
}
.web-msg-display-area {
  width: 320px;
  min-height: 112px;
  background: #fab801;
  padding: 15px;
  border-radius: 8px;
  position: absolute;
  top: 25px;
  right: 0px;
  z-index: 999;
}
.web-msg-wrapper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.web-msg-display-area h3 {
  word-break: break-all;
}
.web-msg-display-area p {
  word-break: break-all;
}
.drop-right-wrap {
  width: 82%;
}
.drag-drop-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.drag-drop-wrap .vs-list--item {
  width: 30.6%;
  margin: 0 10px;
}
// .mobile-img {
//   display: none;
// }
.notification-sreen-wrapper {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.notification-sreen-wrapper img {
  width: 100%;
}
span.cross-btn {
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.tab-notification-content {
    background: #fff;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 0 8px rgba(0,0,0,0.2);
}
.notification-outer-wrap{align-items: stretch;}
.notification-outer-wrap .vue-form-wizard {height: 100%;}
.notification-outer-wrap .vue-form-wizard.vertical .wizard-navigation{height: 84%;}
.notification-outer-wrap .vue-form-wizard.vertical .wizard-card-footer{height: 16%;}
.notification-outer-wrap .wizard-tab-container{width: 100%;}
.notification-outer-wrap .wizard-navigation .wizard-tab-content{width: 85%; padding: 0 !important;}
.notification-outer-wrap ul.wizard-nav.wizard-nav-pills {width: 15%;}
</style>
<style lang="scss" scoped>
</style>
<template>
  <div>
    <div class="vx-row notification-outer-wrap">
      <div class="vx-col md:w-8/12 w-full">
        <form-wizard
          color="rgba(var(--vs-primary), 1)"
          :title="null"
          :subtitle="null"
          :startIndex="activeWizard"
          finishButtonText="Submit & Close"
          @on-complete="saveNotification"
          layout="vertical"
          class="tab-notification-content"
        >
          <tab-content
            title="Message says"
            class="mb-5"
            :before-change="before_save"
          >
            <div class="vx-row">
              <div class="vx-col md:w-1/1 w-full">
                <vs-input
                  label="Notification Title"
                  class="mt-5 w-full"
                  name="NotificationName"
                  v-model="NotificationName"
                  data-vv-as="Notification Name"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('NotificationName')"
                  >{{ errors.first("NotificationName") }}</span
                >
              </div>

              <div class="vx-col md:w-1/1 w-full mt-5">
                <label>Notification Message</label>
                <vs-textarea
                  class="w-full"
                  name="NotificationMessage"
                  v-model="NotificationMessage"
                  data-vv-as="Notification Message"
                  v-validate="'required'"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('NotificationMessage')"
                  >{{ errors.first("NotificationMessage") }}</span
                >
              </div>
              <div class="vx-col md:w-1/1 w-full mt-5">
                <label>
                  Deep Link
                </label>
                <v-select
                  class="w-full select-large"
                  v-model="DeepLink"
                  :options="landingURLOptions"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </div>
            </div>
          </tab-content>
          <tab-content
            title="Who will get it"
            class="mb-5"
            :before-change="before_save"
          >
            <div>
              <vs-radio
                v-model="sourceselected"
                vs-value="allatendees"
                class="mr-4"
                vs-name="sourceselected"
                @change="onSelectButtonChange"
                >All Attendees</vs-radio
              >
              <vs-radio
                v-model="sourceselected"
                vs-value="selectedattendees"
                class="mr-4"
                vs-name="sourceselected"
                @change="onSelectButtonChange"
                >Select Attendees</vs-radio
              >
              <vs-radio
                v-model="sourceselected"
                vs-value="selectedgroups"
                class="mr-4"
                vs-name="sourceselected"
                @change="onSelectButtonChange"
                >Select Groups</vs-radio
              >
            </div>
            <br />
            <vx-card v-show="IsAttendeeSelect">
              <div class="clsnotification">
                <div>
                  <div class="table-seating-wrapper">
                    <h5>Drag and Drop Attendee(s) to your right</h5>
                    <p>&nbsp;</p>
                  </div>
                  <div class="attendee-searchbox my-5 px-3">
                    <vs-input
                      icon="search"
                      class="inputx w-full searchbox"
                      placeholder="Search Attendee"
                      v-model="attendeeName"
                      @keyup="searchAttendee"
                    />
                  </div>
                  <div
                    class="attendee-list-wrap"
                    style="
                      align-items: flex-start;
                      height: 400px;
                      overflow-y: auto;
                    "
                  >
                    <draggable
                      :list="searchAttendee"
                      :move="checkMoveAttendeeSelected"
                      :group="{
                        name: 'people',
                        pull: 'clone',
                        put: false,
                      }"
                      class="p-2 cursor-move"
                    >
                      <vs-list-item
                        v-for="(listItem, index) in searchAttendee"
                        :key="index"
                        :title="listItem.Name"
                        :subtitle="listItem.Email"
                      >
                      </vs-list-item>
                    </draggable>
                  </div>
                </div>
                <div class="drop-right-wrap">
                  <div class="single-table-wrap">
                    <div class="attendee-catagory-drop-wrap pl-2">
                      <vs-list class="mt-5">
                        <div class="guest-wrapper">
                          <div class="attendee-table-select-head">
                            Selected Attendees
                            <!-- <span>(Max {{ maxGuest }})</span> -->
                          </div>
                          <div class="attendee-guest-list-wrap">
                            <draggable
                              :list="selectedAttendee_list"
                              :move="checkOverflowHost"
                              :group="{ name: 'people', put: guestPut }"
                              class="p-2 cursor-move mt-5 drag-drop-wrap"
                            >
                              <vs-list-item
                                :class="
                                  attendeesonothertable.includes(
                                    listItem.AttendeeId
                                  )
                                    ? 'bordered'
                                    : 'normal'
                                "
                                v-for="(
                                  listItem, index
                                ) in selectedAttendee_list"
                                :key="index"
                                :title="listItem.Name"
                              >
                                <span
                                  class="cross-btn"
                                  @click="removeAttendee(listItem.AttendeeId)"
                                  ><feather-icon class="iconsize" icon="XIcon"
                                /></span>
                              </vs-list-item>
                            </draggable>
                          </div>
                        </div>
                      </vs-list>
                    </div>
                  </div>
                </div>
              </div>
            </vx-card>

            <!-- <div v-show="ISGroupSelect"> -->
            <vx-card v-show="ISGroupSelect">
              <div class="clsnotification">
                <div>
                  <div class="table-seating-wrapper">
                    <div class="single-table-wrap">
                      <div class="single-table-wrap-top px-3 py-3">
                        <!-- <h5>Select Group</h5> -->
                        <!-- <v-select
                              multiple
                              v-model="modelGroup"
                              :closeOnSelect="false"
                              label="Name"
                              :options="groupList"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            /> -->

                        <h5>Drag and Drop Groups to your right</h5>
                        <p>&nbsp;</p>
                      </div>
                      <div class="attendee-searchbox my-5 px-3">
                        <vs-input
                          icon="search"
                          class="inputx w-full searchbox"
                          placeholder="Search Attendee"
                          v-model="groupname"
                          @keyup="searchGroups"
                        />
                      </div>
                      <div class="attendee-list-select-wrap">
                        <div
                          class="attendee-list-wrap"
                          style="
                            align-items: flex-start;
                            height: 400px;
                            overflow-y: auto;
                          "
                        >
                          <draggable
                            :list="searchGroups"
                            :move="checkGroupsMoveSelected"
                            :group="{
                              name: 'people',
                              pull: 'clone',
                              put: false,
                            }"
                            class="p-2 cursor-move"
                          >
                            <vs-list-item
                              v-for="(listItem, index) in searchGroups"
                              :key="index"
                              :title="listItem.GroupName"
                            >
                            </vs-list-item>
                          </draggable>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="drop-right-wrap">
                  <div class="single-table-wrap no-border">
                    <div class="attendee-catagory-drop-wrap pl-2">
                      <vs-list class="mt-5">
                        <div class="guest-wrapper">
                          <div class="attendee-table-select-head">
                            Selected Groups
                            <!-- <span>(Max {{ maxGuest }})</span> -->
                          </div>
                          <div class="attendee-guest-list-wrap">
                            <!-- <draggable
                                  :list="guest_list"
                                  :move="checkOverflowHost"
                                  :group="{ name: 'people', put: guestPut }"
                                  class="p-2 cursor-move mt-5"
                                > -->
                            <draggable
                              :list="selectedGroup_List"
                              :move="checkOverflowHost"
                              :group="{ name: 'people', put: guestPut }"
                              class="p-2 cursor-move mt-5 drag-drop-wrap"
                            >
                              <vs-list-item
                                :class="
                                  groupsonothertable.includes(listItem.GroupId)
                                    ? 'bordered'
                                    : 'normal'
                                "
                                v-for="(listItem, index) in selectedGroup_List"
                                :key="index"
                                :title="listItem.GroupName"
                              >
                                <span
                                  class="cross-btn"
                                  @click="removeGroup(listItem.GroupId)"
                                  ><feather-icon class="iconsize" icon="XIcon"
                                /></span>
                              </vs-list-item>
                            </draggable>
                          </div>
                        </div>
                      </vs-list>
                    </div>
                    <!-- Save & Reset Button -->
                    <!-- <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="mt-8 flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" @click="before_save"
                      >Save Changes</vs-button
                    >
                  </div>
                </div>
              </div> -->
                  </div>
                </div>
              </div>
            </vx-card>
            <!-- </div> -->
          </tab-content>

          <tab-content
            title="When will get it"
            class="mb-5"
            :before-change="before_save"
          >
            <!-- <div class="mt-3 theme-select-flex-box">
                    <span class="lobbtTagText">Is Scheduled</span>

                    <vs-switch v-model="IsScheduled" @change="onSubButtonChange">
                      <span slot="On" vs-value="2" name="lobbySubButton">On</span>
                      <span slot="Off" vs-value="1" name="lobbySubButton">Off</span>
                    </vs-switch>
                  </div> -->

            <vs-radio
              v-model="scheduleSelcted"
              vs-value="Now"
              class="mr-4"
              vs-name="Source-select-notification"
              @change="onSubButtonChange"
              >Now</vs-radio
            >
            <vs-radio
              v-model="scheduleSelcted"
              vs-value="Scheduled"
              class="mr-4 hidden"
              vs-name="Source-select-notification"
              @change="onSubButtonChange"
              >Schedule</vs-radio
            >

            <div v-show="IsScheduled" class="vx-col md:w-1/2 w-full mt-5">
              <label style="padding-right: 10px">Select Date and Time</label>
              <flat-pickr
                :config="configdateTimePickerStart"
                name="Schedule Date"
                v-model="ScheduleDate"
                placeholder="Schedule Date"
                class="time-pkr"
                style="padding-right: 10px"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Start Time')"
                style="padding-right: 10px"
                >{{ errors.first("Start Time") }}</span
              >
              {{ EventData.TimeZone }}
            </div>
          </tab-content>
        </form-wizard>
      </div>
      <div class="vx-col md:w-4/12 w-full">
        <div class="push-section mb-5">
          <p class="mr-5">Switch Preview - </p>
          <vs-button
            color="success"
            size="small"
            type="filled"
            class="mr-3"
            @click="changeView()"
            >Smart Phone</vs-button
          >
          <vs-button
            color="primary"
            size="small"
            type="border"
            @click="changeView()"
            >Web</vs-button
          >
        </div>
        <div v-show="showMobileView" class="mobile-img">
          <img
            src="../../assets/images/mobile-notification-img.png"
            alt="Mobile Image"
          />
          <div class="push-msg-display-area">
            <h3>{{ NotificationName }}</h3>
            <!-- <h4>Subtitle</h4> -->
            <p>{{ NotificationMessage }}</p>
          </div>
        </div>

        <div v-show="showWebView" class="web-msg-wrapper">
          <div class="notification-sreen-wrapper">
            <img
              src="../../assets/images/live-stage-console.jpg"
              alt="web-image"
            />
            <div class="web-msg-display-area">
              <h3>{{ NotificationName }}</h3>
              <!-- <h4>Subtitle</h4> -->
              <p>{{ NotificationMessage }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import draggable from "vuedraggable";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment-timezone";
import axios from "@/axios.js";
import con from "@/firebase/firebaseInit.ts";

// Store Module
var FirebaseAuthApi = con.FirebaseAuthApi;
import moduleNotificationManagement from "@/store/notification-management/moduleNotificationManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
let GetsendpushApi = con.GetsendpushApi;
let GetGroupPushApi = con.GetGroupPushApi;
let sendpushApiKey = con.sendpushApiKey;
let GetAllTopicPushApi = con.GetAllTopicPushApi;
let SendAttendeeAndGroupPushAPI = con.SendAttendeeAndGroupPushAPI;
let clientId = ls.getSessionValueByKey("Session_Client_Id");
let eventId = ls.getSessionValueByKey("Session_Event_Id");
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import VxBreadcrumbVue from "../../layouts/components/VxBreadcrumb.vue";
var Session_UserId = ls.getSessionValueByKey("UserId");
var eventID = ls.getSessionValueByKey("Session_Event_Id");
var vm;
export default {
  components: {
    FormWizard,
    TabContent,
    draggable,
    AgGridVue,
    vSelect,
    quillEditor,
    flatPickr,

    // Cell Renderer
    // CellRendererLink,
    // CellRendererStatusReg,
    // CellRendererAmountReg,
    // CellRendererTransactionIDReg,
    // CellRendererSourceReg,
    // CellRendererCreatedOnReg,
    // CellRendererVerified,
    CellRendererActions,
  },
  props: {},
  data() {
    return {
      showMobileView: true,
      showWebView: false,
      activeWizard: 0,
      popupUploadActive: false,
      scheduleSelcted: "Now",
      sourceselected: "allatendees",
      attendee_list: [],
      group_list: [],
      IsAllattendeeSelect: true,
      IsAttendeeSelect: false,
      ISGroupSelect: false,
      IsAllAttendeeSelect: true,
      groupList: [],
      modelGroup: [],
      attendeesonothertable: [],
      groupsonothertable: [],
      hostPut: true,
      guestPut: true,
      maxGuest: "1000",
      attendeeName: "",
      groupname: "",
      attendee_search_list: [],
      group_search_list: [],
      notificationLists: [],
      host_list: [],
      guest_list: [],
      selectedAttendee_list: [],
      selectedGroup_List: [],
      EventData: [],
      modelAttendee: [],
      attendessList: [],
      NotificationName: "",
      NotificationMessage: "",
      DeepLink: null,
      landingURLOptions: [
        "/lobby",
        "/sessions",
        "/livestage",
        "/attendee",
        "/exhibitorshall",
        "/mymeetings",
        "/myprofile",
      ],
      ScheduleDate: "",
      IsScheduled: false,
      popupActiveAddNotification: false,
      StartDate: null,
      EndDate: null,
      LSDateTime: null,
      configdateTimePicker: {
        minDate: new Date(),
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      configdateTimePickerStart: {
        minDate: new Date(),
        maxDate: null,
        onChange: function (val) {
          //if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
      },
      ScheduleDate: "",
      EventData: [],
    };
  },
  computed: {
    searchGroups() {
      debugger;
      let groupname = vm.groupname.trim().toLowerCase();

      if (groupname) {
        return vm.group_search_list.filter((row) => {
          if (row.GroupName !== undefined && row.GroupId !== undefined) {
            return (
              row.GroupName.toLowerCase().includes(groupname) ||
              row.GroupId.toLowerCase().includes(groupname)
            );
          }
        });
      } else {
        return vm.group_search_list;
      }
    },
    searchAttendee() {
      debugger;
      let attendeeName = vm.attendeeName.trim().toLowerCase();

      if (attendeeName) {
        return vm.attendee_search_list.filter((row) => {
          if (
            row.FirstName !== undefined &&
            row.LastName !== undefined &&
            row.Email !== undefined
          ) {
            return (
              row.FirstName.toLowerCase().includes(attendeeName) ||
              row.LastName.toLowerCase().includes(attendeeName) ||
              row.Email.toLowerCase().includes(attendeeName)
            );
          }
        });

        // vm.attendee_search_list.filter((row) => {
        //   if (
        //     row.FirstName !== undefined &&
        //     row.LastName !== undefined &&
        //     row.Email !== undefined
        //   ) {
        //     if (
        //       row.FirstName.toLowerCase().includes(attendeeName) ||
        //       row.LastName.toLowerCase().includes(attendeeName) ||
        //       row.Email.toLowerCase().includes(attendeeName)
        //     ) {
        //       return true;
        //     } else {
        //       return false;
        //     }
        //   }
        // });
      } else {
        return vm.attendee_search_list; //this.attendee_search_list = this.attendee_list;
      }
    },
  },
  methods: {
    removeAttendee(id) {
      let index = vm.selectedAttendee_list
        .map((x) => {
          return x.AttendeeId;
        })
        .indexOf(id);

      vm.selectedAttendee_list.splice(index, 1);
    },
    removeGroup(id) {
      let index = vm.selectedGroup_List
        .map((x) => {
          return x.GroupId;
        })
        .indexOf(id);

      vm.selectedGroup_List.splice(index, 1);
    },
    changeView() {
      debugger;
      if (vm.showMobileView) {
        vm.showMobileView = false;
        vm.showWebView = true;
      } else if (vm.showWebView) {
        vm.showMobileView = true;
        vm.showWebView = false;
      }
    },
    fetch_groups() {
      this.$store
        .dispatch("NotificationManagement/fetchgroups", null)
        .then((res) => {
          vm.group_search_list = this.group_list = res.filter((row) => {
            return row.GroupName !== "";
          });
          /*  this.group_list = this.group_list.sort((a, b) => {
            let fa = a.GroupName.toLowerCase();
            let fb = b.GroupName.toLowerCase();
            if (fa < fb) {
              return -1;
            }
            if (fa > fb) {
              return 1;
            }
            return 0;
          });*/
        });
    },
    fetch_attendees() {
      this.$store
        .dispatch("attendeeManagement/fetchAttendees", null)
        .then((res) => {
          this.attendee_search_list = this.attendee_list = res.filter((row) => {
            return row.IsPublished;
          });
          debugger;
          console.log(this.attendee_search_list);
          // this.attendee_list = this.attendee_list.sort((a, b) => {
          //   let fa = a.FirstName.toLowerCase();
          //   let fb = b.FirstName.toLowerCase();
          //   if (fa < fb) {
          //     return -1;
          //   }
          //   if (fa > fb) {
          //     return 1;
          //   }
          //   return 0;
          // });
        });
    },
    getAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        for (let i = 0; i < res.length; i++) {
          this.attendessList.push({
            AttendeeId: res[i].AttendeeId,
            Company: res[i].Company,
            Designation: res[i].Designation,
            Email: res[i].Email,
            FirstName: res[i].FirstName,
            LastName: res[i].LastName,
            Name: res[i].Name,
            Phone: res[i].Phone,
            ProfilePictureURL: res[i].ProfilePictureURL,
          });
        }
        console.log(this.attendessList);
      });
    },
    getGroups() {
      this.$store.dispatch("NotificationManagement/fetchgroups").then((res) => {
        for (let i = 0; i < res.length; i++) {
          debugger;
          vm.groupList.push({
            GroupId: res[i].GroupId,
            GroupName: res[i].GroupName,
          });
        }

        console.log(vm.groupList);
      });
    },
    fetch_event_data() {
      let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
      this.$store
        .dispatch("eventManagement/fetchEvent", Session_Event_Id)
        .then((res) => {
          vm.EventData = res.data;
        });
    },
    onSubButtonChange: function (context, LobbyType) {
      //debugger
      if (vm.scheduleSelcted == "Now") {
        this.IsScheduled = false;
      } else if (vm.scheduleSelcted == "Scheduled") {
        this.IsScheduled = true;
      }
    },
    checkGroupsMoveSelected: function (evt) {
      console.log(this.host_list.length);
      let ID = evt.draggedContext.element.GroupId;
      let Name = evt.draggedContext.element.GroupName;
      let found = this.host_list.some((el) => el.GroupId === ID);
      let foundl = vm.selectedGroup_List.some((el) => el.GroupId === ID);
      if (found || foundl) {
        return false;
      } else {
        // this.checkUserOnOtherTable(ID, Name);
        return true;
      }
      //true;
    },
    checkOverflowHost(evt) {
      //console.log(this.host_list.length)
      // return this.host_list.length == 0 ? true : false;
      true;
    },
    checkMoveAttendeeSelected: function (evt) {
      // console.log(this.host_list.length);
      let ID = evt.draggedContext.element.AttendeeId;
      let Name = evt.draggedContext.element.Name;
      let found = this.host_list.some((el) => el.AttendeeId === ID);
      let foundl = this.selectedAttendee_list.some(
        (el) => el.AttendeeId === ID
      );
      if (found || foundl) {
        return false;
      } else {
        // this.checkUserOnOtherTable(ID, Name);
        return true;
      }
      //true;
    },
    onSelectButtonChange: function (context, LobbyType) {
      debugger;
      if (vm.sourceselected == "selectedattendees") {
        vm.IsAllAttendeeSelect = false;
        this.ISGroupSelect = false;
        this.IsAttendeeSelect = true;
      } else if (vm.sourceselected == "selectedgroups") {
        vm.IsAllAttendeeSelect = false;
        this.ISGroupSelect = true;
        this.IsAttendeeSelect = false;
      } else if (vm.sourceselected == "allatendees") {
        vm.IsAllAttendeeSelect = true;
        this.ISGroupSelect = false;
        this.IsAttendeeSelect = false;
      }
    },

    before_save() {
      console.log("validate");
      return new Promise((resolve, reject) => {
        vm.$validator.validateAll().then((result) => {
          console.log(result);
          resolve(result);
        });
      });
    },
    getFirebaseAccessToken: function () {
      return new Promise((resolve, reject) => {
        let accessToken = ls.getSessionValueByKey("Session_AccessToken")
        resolve(accessToken);
      });
    },
    saveNotification: function () {
      debugger;
      var cn = ls.getSessionEventCollectionName();

      if (vm.NotificationName == "" || vm.NotificationMessage == "") {
        vm.$vs.notify({
          color: "warning",
          position: "top-center",
          title: "Notification",
          text: "Please fill up notification title and message!",
        });
      } else {
        if (vm.IsAttendeeSelect) {
          vm.$vs.loading();

          var localAttendees = [];
          this.selectedAttendee_list.forEach(function (rowArray) {
            localAttendees.push({
              AttendeeID: rowArray.AttendeeId,
              Email: rowArray.Email,
              Name: rowArray.Name,
            });
          });

          var cRef = con.eventDB
            .collection(cn)
            .doc("NotificationList")
            .collection("Notifications");
          //.doc(rowArray.AttendeeId);

          var docObj = new Object();
          docObj.Attendees = localAttendees;
          //docObj.AttendeeID = rowArray.AttendeeId;
          docObj.Type = 2;
          docObj.CreatedDate = new Date();
          // docObj.Email = rowArray.Email;
          docObj.LastModifiedDate = new Date();
          docObj.IsScheduled = vm.IsScheduled;
          docObj.NotificationTitle = vm.NotificationName;
          docObj.NotificationMessage = vm.NotificationMessage;
          docObj.DeepLink = vm.DeepLink;
          docObj.scheduleDateTime =
            vm.ScheduleDate == ""
              ? ""
              : vm.GetTimeByZone(vm.ScheduleDate, vm.EventData.TimeZone);
          docObj.status = vm.IsScheduled ? "scheduled" : "sent";
          if (localAttendees.length > 0) {
            cRef
              .add(docObj)
              .then(function (e) {
                console.log("success");
                //console.log(e);

                //-----------------------Notification---------------------------------
                for (var i = 0; i < localAttendees.length; i++) {
                  console.log(localAttendees[i].AttendeeID);
                  var localattendeeId = localAttendees[i].AttendeeID;
                  var subscrRef = con.eventDB
                    .collection(cn)
                    .doc("SubscribersList")
                    .collection("Subscriptions")
                    .doc(localAttendees[i].AttendeeID);


                       // console.log(doc.data().Devices);
                        debugger;
                        if (vm.IsScheduled) {
                          debugger;
                          vm.$vs.loading.close();
                          vm.selectedAttendee_list = [];
                          vm.attendeeName = "";
                          vm.NotificationName = "";
                          vm.NotificationMessage = "";
                          vm.DeepLink = null;
                          vm.$vs.notify({
                            color: "success",
                            position: "top-center",
                            title: "Notification",
                            text: "Notification scheduled!",
                          });
                          //location.reload();
                          vm.$router.push("/event/notification");
                        } else {
                          return new Promise((resolve, reject) => {
                            vm.getFirebaseAccessToken().then((accessToken) => {
                              let headers = {
                                Authorization: `Bearer ${accessToken}`,
                                "content-type": "application/json",
                              };
                              console.log(JSON.stringify(headers));
                              let requestData = {
                                key: {
                                  instanceId: "OA_UAT",
                                  clientId: clientId,
                                  eventId: eventId,
                                },
                                data: {
                                  NotificationId: e.id,
                                },
                              };
                              console.log(SendAttendeeAndGroupPushAPI);
                              console.log(JSON.stringify(requestData));

                              axios
                                .post(
                                  SendAttendeeAndGroupPushAPI,
                                  requestData,
                                  {
                                    headers: headers,
                                  }
                                )
                                .then((response) => {
                                  //console.log(response)
                                  vm.$vs.loading.close();
                                  resolve({
                                    status: 200,
                                    message: "Notification Sent successfully",
                                  });
                                  vm.$vs.notify({
                                    color: "success",
                                    position: "top-center",
                                    title: "Notification",
                                    text: "Notification Sent successfully!",
                                  });
                                  vm.$router.push("/event/notification/");
                                })
                                .catch((error) => {
                                  vm.$vs.loading.close();
                                  console.log(error);
                                  resolve({
                                    status: 500,
                                    message: "Something went wrong",
                                  });
                                });
                            });
                            //})
                          });
                        }
                        //++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
                      
                }

                //--------------------------------------------------------------------

                vm.host_list = [];
                vm.guest_list = [];
                // vm.popupActiveAddNotification = false;
              })
              .catch((error) => {
                vm.$vs.loading.close();
                vm.host_list = [];
                vm.guest_list = [];
                vm.selectedAttendee_list = [];
                //   vm.popupActiveAddNotification = false;
                alert(error);
              });
          } else {
            vm.$vs.loading.close();
            vm.host_list = [];
            vm.guest_list = [];
            vm.selectedAttendee_list = [];
            //  vm.popupActiveAddNotification = false;
          }
          //}
          // })
          // .catch((err) => {
          //   //console.error(err)
          //   this.$vs.loading.close();
          //   vm.popupActiveAddNotification = false;
          // });

          //vm.popupActiveAddNotification = false;
        } else if (vm.ISGroupSelect) {
          vm.$vs.loading();
          debugger;
          var arrLoccalgroup = [];
          var grpids = "";
          for (var i = 0; i < vm.selectedGroup_List.length; i++) {
            //arrLoccalgroup.push(vm.selectedGroup_List[i].GroupId.toString());

            arrLoccalgroup.push({
              GroupId: vm.selectedGroup_List[i].GroupId.toString(),
              GroupName: vm.selectedGroup_List[i].GroupName.toString(),
            });
          }

          debugger;
          var docObj = new Object();
          docObj.Groups = arrLoccalgroup;
          docObj.Type = 2;
          docObj.CreatedDate = new Date();
          docObj.LastModifiedDate = new Date();
          docObj.IsScheduled = vm.IsScheduled;
          docObj.NotificationTitle = vm.NotificationName;
          docObj.NotificationMessage = vm.NotificationMessage;
          docObj.DeepLink = vm.DeepLink;
          docObj.scheduleDateTime =
            vm.ScheduleDate == ""
              ? ""
              : vm.GetTimeByZone(vm.ScheduleDate, vm.EventData.TimeZone);
          docObj.status = vm.IsScheduled ? "scheduled" : "sent";

          if (arrLoccalgroup.length > 0) {
            var cRef = con.eventDB
              .collection(cn)
              .doc("NotificationList")
              .collection("Notifications");
            debugger;
            cRef
              .add(docObj)
              .then(function (e) {
                console.log("success");

                if (vm.IsScheduled) {
                  debugger;
                  vm.$vs.loading.close();
                  vm.selectedGroup_List = [];
                  vm.groupname = "";
                  vm.NotificationName = "";
                  vm.NotificationMessage = "";
                  vm.DeepLink = null;
                  vm.$vs.notify({
                    color: "success",
                    position: "top-center",
                    title: "Notification",
                    text: "Notification scheduled!",
                  });
                  //   location.reload();
                  vm.$router.push("/event/notification/add");
                } else {
                  //----------------------- GROUP PUSH ------------------------------------------------------------
                  return new Promise((resolve, reject) => {
                    vm.getFirebaseAccessToken().then((accessToken) => {
                      let headers = {
                        Authorization: `Bearer ${accessToken}`,
                        "content-type": "application/json",
                      };
                      console.log(JSON.stringify(headers));
                      let requestData = {
                        key: {
                          instanceId: "OA_UAT",
                          clientId: clientId,
                          eventId: eventId,
                        },
                        data: {
                          NotificationId: e.id,
                        },
                      };
                      console.log(SendAttendeeAndGroupPushAPI);
                      console.log(JSON.stringify(requestData));

                      axios
                        .post(SendAttendeeAndGroupPushAPI, requestData, {
                          headers: headers,
                        })
                        .then((response) => {
                          //console.log(response)
                          vm.$vs.loading.close();
                          resolve({
                            status: 200,
                            message: "Notification Sent successfully",
                          });
                          vm.$vs.notify({
                            color: "success",
                            position: "top-center",
                            title: "Notification",
                            text: "Notification Sent successfully!",
                          });
                          vm.$router.push("/event/notification/");
                        })
                        .catch((error) => {
                          vm.$vs.loading.close();
                          console.log(error);
                          resolve({
                            status: 500,
                            message: "Something went wrong",
                          });
                        });
                    });
                    //})
                  });

                  //----------------------------------------------------------------------------------------------
                }
                debugger;
                vm.host_list = [];
                vm.guest_list = [];
                vm.selectedGroup_List = [];
                vm.groupname = "";
                vm.NotificationName = "";
                vm.NotificationMessage = "";
                vm.DeepLink = null;
                //vm.popupActiveAddNotification = false;
              })
              .catch((error) => {
                debugger;
                vm.$vs.loading.close();
                vm.host_list = [];
                vm.guest_list = [];
                vm.selectedGroup_List = [];
                vm.groupname = "";
                vm.NotificationName = "";
                vm.NotificationMessage = "";
                vm.DeepLink = null;
                location.reload();
                vm.$vs.notify({
                  color: "warning",
                  position: "top-center",
                  title: "Notification",
                  text: "Something went wrong!",
                });
                //vm.popupActiveAddNotification = false;
                // alert(error);
              });
          }
        } else if (vm.IsAllAttendeeSelect) {
          vm.$vs.loading();
          debugger;
          debugger;
          var docObj = new Object();
          docObj.TopicConvention = cn;
          docObj.Type = 1;
          docObj.CreatedDate = new Date();
          docObj.LastModifiedDate = new Date();
          docObj.IsScheduled = vm.IsScheduled;
          docObj.NotificationTitle = vm.NotificationName;
          docObj.NotificationMessage = vm.NotificationMessage;
          docObj.DeepLink = vm.DeepLink;
          docObj.scheduleDateTime =
            vm.ScheduleDate == ""
              ? ""
              : vm.GetTimeByZone(vm.ScheduleDate, vm.EventData.TimeZone);
          docObj.status = vm.IsScheduled ? "scheduled" : "sent";

          var cRef = con.eventDB
            .collection(cn)
            .doc("NotificationList")
            .collection("Notifications");
          debugger;
          cRef.add(docObj).then(function (e) {
            console.log("success");
            //----------------------- TOPIC PUSH [Type=1] ------------------------------------------------------------
            return new Promise((resolve, reject) => {
              vm.getFirebaseAccessToken().then((accessToken) => {
                let headers = {
                  Authorization: `Bearer ${accessToken}`,
                  "content-type": "application/json",
                };
                console.log(JSON.stringify(headers));
                let requestData = {
                  key: {
                    instanceId: "OA_UAT",
                    clientId: clientId,
                    eventId: eventId,
                  },
                  data: {
                    NotificationId: e.id,
                  },
                };
                console.log(SendAttendeeAndGroupPushAPI);
                console.log(JSON.stringify(requestData));

                axios
                  .post(SendAttendeeAndGroupPushAPI, requestData, {
                    headers: headers,
                  })
                  .then((response) => {
                    //console.log(response)
                    vm.$vs.loading.close();
                    resolve({
                      status: 200,
                      message: "Notification Sent successfully",
                    });
                    vm.$vs.notify({
                      color: "success",
                      position: "top-center",
                      title: "Notification",
                      text: "Notification Sent successfully!",
                    });
                    vm.$router.push("/event/notification/");
                  })
                  .catch((error) => {
                    vm.$vs.loading.close();
                    console.log(error);
                    resolve({
                      status: 500,
                      message: "Something went wrong",
                    });
                  });
              });
              //})
            });

            //----------------------------------------------------------------------------------------------
          });
        }

        //------------------------------------------------------------------------------
      }
    },

    GetTimeByZone: function (strDateTime, timeZone) {
      debugger;
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
  },
  created() {
    vm = this;
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    if (!moduleNotificationManagement.isRegistered) {
      this.$store.registerModule(
        "NotificationManagement",
        moduleNotificationManagement
      );
      moduleNotificationManagement.isRegistered = true;
    }
    this.fetch_event_data();
    this.getGroups();
    this.getAttendees();

    this.fetch_attendees();
    vm.fetch_groups();
  },
};
</script>
<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>